export default {
    SYSTEM_ID: "",
    imageReplacerDamageType: [],
    imageReplacerWeaponProperties: [],
    imageReplacerIconizer: [],
};
